import { useCallback } from "react";
import useAjax from "@apis/useAjax";
import { GET_SYSTEM_BUILD_TIME_API, GET_SYSTEM_TAIPEI_TIME_API } from "@apis/apiPath";

const useAppSystemApi = () => {
	const Ajax = useAjax();

	const getWebClubInfoApi = useCallback(
		async () => {
			const resp = await Ajax.get(GET_SYSTEM_BUILD_TIME_API);
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	const getTaipeiTimeApi = useCallback(
		async () => {
			const resp = await Ajax.get(GET_SYSTEM_TAIPEI_TIME_API);
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	return {
		getWebClubInfoApi,
		getTaipeiTimeApi,
	};
};

export default useAppSystemApi;
